export default {
    'journey.contact' : {
        'model': 'Contact', // registered in common/v1/definition/PropagationModels
        'profileSync': {
            'toProfile' : {
                'enable': true,
                'overwrite': true,
                'properties': [ 'firstName', 'lastName', 'phone', 'email', 'dob', 'language' ],
            },
            'fromProfile' : {
                'enable': true,
                // if doc already has, do not overwrite the value,
                // this option applies to each field, not model itself
                // ex) if firstName already exists, do not overwrite
                // ex) if lastName does not exist, write
                'overwrite': false,
                'properties': [ 'firstName', 'lastName', 'phone', 'email', 'dob', 'language' ],
            },
            'profilePath': '$', // $ represent root of profile object
        },
    },
};
